import { useState } from "react";
import { Nav, JourneyRail, MobileBar, BackToTop } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { StagePicker, Story, Bridge } from "@/components/site/Intro";
import { FivePs } from "@/components/site/FivePs";
import { Offer } from "@/components/site/Offer";
import { Testimonials } from "@/components/site/Testimonials";
import { Quiz } from "@/components/site/Quiz";
import { LessonExplorer } from "@/components/site/LessonExplorer";
import { SampleLesson } from "@/components/site/SampleLesson";
import { Assistant } from "@/components/site/Assistant";
import { Booking } from "@/components/site/Booking";
import { Scott } from "@/components/site/Scott";
import { BrandStory } from "@/components/site/BrandStory";
import { Faq, Final, Footer } from "@/components/site/Closing";
import { StickyBuyBar } from "@/components/site/StickyBuyBar";
import { useLenis, useAnchorScroll, useReveal, useSectionPointer, useScrollMeta, useRailIndex } from "@/hooks/useSiteEffects";

export default function Home() {
  const [activeP, setActiveP] = useState("purpose");
  const [stickyText, setStickyText] = useState("From Campus to Corporate");
  useLenis();
  useAnchorScroll();
  useReveal();
  useSectionPointer();
  const { progress, scrolled } = useScrollMeta();
  const rail = useRailIndex();

  return (
    <>
      <Nav scrolled={scrolled} progress={progress} />
      <JourneyRail index={rail.index} sections={rail.sections} />
      <main id="top">
        <Hero />
        <Marquee />
        <StagePicker />
        <Story />
        <Bridge />
        <FivePs activeP={activeP} setActiveP={setActiveP} />
        <Offer />
        <Testimonials />
        <Quiz setActiveP={setActiveP} onResult={(name) => setStickyText(`Your 5Ps focus: ${name}`)} />
        <LessonExplorer />
        <SampleLesson />
        <Assistant />
        <Booking />
        <Scott />
        <BrandStory />
        <Faq />
        <Final />
      </main>
      <Footer />
      <BackToTop />
      <StickyBuyBar />
      <MobileBar stickyText={stickyText} />
    </>
  );
}
